/* eslint-disable no-shadow */
/* eslint-disable import/no-cycle */
import {
  ActionTree, Module, GetterTree, MutationTree
} from 'vuex';
import IRootState from '../states/interfaces/index.d';
import PersonalDetailsState from '../states/personal-details-state';
import IPersonalDetailsState from '../states/interfaces/personal-details-state.d';
import EmailValidationResult from '../../models/EmailValidationResult';

export const state: IPersonalDetailsState = new PersonalDetailsState();
export const getters: GetterTree<IPersonalDetailsState, IRootState> = {
  personalDetails: (state) => state.personalDetails,
  isValidVerificationCode: (state) => state.isValidVerificationCode,
  isPrePhoneEntry: (state) => state.isPrePhoneEntry,
  emailCapture: (state) => state.emailCapture
};
export const mutations: MutationTree<IPersonalDetailsState> = {
  setTitle: (state: PersonalDetailsState, title: string | null) => {
    state.personalDetails.title = title;
  },
  setFirstName: (state: PersonalDetailsState, firstName: string) => {
    state.personalDetails.firstName = firstName;
  },
  setLastName: (state: PersonalDetailsState, lastName: string) => {
    state.personalDetails.surname = lastName;
  },
  setEmail: (state: PersonalDetailsState, email: string) => {
    state.personalDetails.email = email;
  },
  setTelephone: (state: PersonalDetailsState, telephone: string) => {
    state.personalDetails.telephone = telephone;
  },
  setIsValidVerificationCode: (state: PersonalDetailsState, isValidVerificationCode: boolean) => {
    state.isValidVerificationCode = isValidVerificationCode;
  },
  setIsPrePhoneEntry: (state: PersonalDetailsState, value: boolean) => {
    state.isPrePhoneEntry = value;
  },
  setEmailValidationResult: (state: PersonalDetailsState, value: EmailValidationResult) => {
    state.emailCapture = value;
    if (value && value.isValid) {
      state.personalDetails.email = value.emailAddress;
    }
  }
};
export const actions: ActionTree<IPersonalDetailsState, IRootState> = {
  submitTitle({ commit }, title: string | null) {
    commit('setTitle', title);
  },
  submitFirstName({ commit }, firstName: string) {
    commit('setFirstName', firstName);
  },
  submitLastName({ commit }, lastName: string) {
    commit('setLastName', lastName);
  },
  submitEmail({ commit }, email: string) {
    commit('setEmail', email);
  },
  submitTelephone({ commit }, telephone: string) {
    commit('setTelephone', telephone);
  },
  submitIsValidVerificationCode: ({ commit }, isValidVerificationCode: boolean) => {
    commit('setIsValidVerificationCode', isValidVerificationCode);
  },
  submitIsPrePhoneEntry({ commit }, value: boolean) {
    commit('setIsPrePhoneEntry', value);
  },
  submitEmailValidationResult({ commit }, value: EmailValidationResult) {
    commit('setEmailValidationResult', value);
  }
};
export const personalDetailsModule: Module<IPersonalDetailsState, IRootState> = {
  state,
  actions,
  getters,
  mutations,
  namespaced: true
};
